import { table } from "../models.model";

export const CALCES_PLAZOS_CHOROTEGA_TOTAL: table = {
  columnas: [
    'Código MN',
    'Código ME',
    'Cuenta',
    "Plazo 1-30 días",
    "Plazo 31-90 días",
    "Plazo 0-90 días",
  ],
  filas: [
    {
      type: 'operacion',
      id: 'A101101',
      bandas:[1,1,1],
      descripcion: 'Caja',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A101201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A101201'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A101101','A101201'],
      
    },
    {
      type: 'operacion',
      id: 'A101103',
      bandas:[1,1,1],
      descripcion: 'Depósitos en bancos del interior',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A101203'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101203'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A101203'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101203'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A101103','A101203'],
    },
    {
      type: 'ceros',
      id:'CEROS_01',
      bandas:[0,0,0],
      descripcion: 'Depósitos en el banco central',
      visible: false,
      sumar: ['A101102','A101202']
    },
    {
      type: 'operacion',
      id: 'A102101',
      bandas:[1,1,1],
      descripcion: 'Inversiones en valores',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A102201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A102201'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A102101','A102201'],      
    },
    {
      type: 'operacion',
      id: 'A102102',
      bandas:[1,1,1],
      descripcion: 'Inversiones en fondos especiales',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A102202'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102202'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A102202'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102202'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A102102','A102202'],      
    },
    {
      type: 'operacion',
      id: 'A103101',
      bandas:[1,1,1],
      descripcion: 'Prestamos vigentes',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A103201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A103201'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A103101','A103201'],      
    },
    {
      type: 'operacion',
      id: 'A104101',
      bandas:[1,1,1],
      descripcion: 'Deudores varios',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A104201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A104201'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104101','A104201'],      
    },
    {
      type: 'ceros',
      id:'CEROS_02',
      bandas:[0,0,0],
      descripcion: 'Comisiones por cobrar',
      visible: false,
      sumar: ['A104103','A104203']
    },
    {
      type: 'operacion',
      id: 'A104104',
      bandas:[1,1,1],
      descripcion: 'Intereses sobre préstamos por cobrar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A104204'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104204'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A104204'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104204'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104104','A104204'],      
    },
    {
      type: 'operacion',
      id: 'A104105',
      bandas:[1,1,1],
      descripcion: 'Intereses y dividendos sobre inversiones por cobrar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A104205'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104205'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'A104205'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104205'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104105','A104205'],      
    },
    {
      type: 'subtotal',
      id: 'SUBTOTAL_01',
      bandas: [1,1,1],
      descripcion: 'TOTAL FLUJOS DE ACTIVOS',
      sumar:['A101101','A101103','CEROS_01','A102101','A102102','A103101','A104101','CEROS_02','A104104','A104105'],
      visible: true,
      expandible: true,
      expandido: false
    },
    {
      type: 'operacion',
      id: 'P201108',
      bandas:[1,1,1],
      descripcion: 'Obligaciones por administración',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201108'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201208'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'numero', valor: 0},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201108'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201208'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201108','P201208'],      
    },
    {
      type: 'operacion',
      id: 'P201109',
      bandas:[1,1,1],
      descripcion: 'Acredores varios',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201109'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201209'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201109'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201209'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P201109'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201209'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P201109'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201209'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201109','P201209'],      
    },
    {
      type: 'ceros',
      id:'CEROS_03',
      bandas:[0,0,0],
      descripcion: 'Documentos por pagar',
      visible: false,
      sumar: ['P201120','P201220']
    },
    {
      type: 'operacion',
      id: 'P201121',
      bandas:[1,1,1],
      descripcion: 'Cuentas por pagar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201121'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201221'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201121'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201221'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P201121'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201221'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P201121'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201221'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201121','P201221'],      
    },
    {
      type: 'operacion',
      id: 'P202101',
      bandas:[1,1,1],
      descripcion: 'Depósitos de ahorro',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202201'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202201'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P202101','P202201'],      
    },
    {
      type: 'operacion',
      id: 'P202103',
      bandas:[1,1,1],
      descripcion: 'Depósitos a plazo',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P202103','P202203'],      
    },
    {
      type: 'operacion',
      id: 'P204101',
      bandas:[1,1,1],
      descripcion: 'Obligaciones por préstamos redescontados',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204201'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P204101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204201'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P204101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204201'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P204101','P204201'],      
    },
    {
      type: 'operacion',
      id: 'P204102',
      bandas:[1,1,1],
      descripcion: 'Créditos y obligaciones bancarias',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204202'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204202'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P204102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204202'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P204102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204202'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P204102','P204202'],      
    },
    {
      type: 'operacion',
      id: 'P201112',
      bandas:[1,1,1],
      descripcion: 'Intereses por pagar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201112'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201212'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201112'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201212'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P201112'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201212'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'P201112'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201212'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201112','P201212'],      
    },
    {
      type: 'ceros',
      id:'CEROS_04',
      bandas:[0,0,0],
      descripcion: 'Comisiones por pagar',
      visible: false,
      sumar: ['P201113','P201213']
    },
    {
      type: 'subtotal',
      id: 'SUBTOTAL_02',
      bandas: [1,1,1],
      descripcion: 'TOTAL FLUJOS DE PASIVOS',
      sumar:['P201108','P201109','CEROS_03','P201121','P202101','P202103','P204101','P204102','P201112','CEROS_04'],
      visible: true,
      expandible: true,
      expandido: false
    }
  ]
}
export const CALCES_PLAZOS_CHOROTEGA_MN: table = {
  columnas: [
    'Código MN',
    'Cuenta',
    "Plazo 1-30 días",
    "Plazo 31-90 días",
    "Plazo 0-90 días",
  ],
  filas: [
    {
      type: 'operacion',
      id: 'A101101',
      bandas:[1,1,1],
      descripcion: 'Caja',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101101'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A101101'],
      
    },
    {
      type: 'operacion',
      id: 'A101103',
      bandas:[1,1,1],
      descripcion: 'Depósitos en bancos del interior',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101103'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101103'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A101103'],
    },
    {
      type: 'ceros',
      id:'CEROS_01',
      bandas:[0,0,0],
      descripcion: 'Depósitos en el banco central',
      visible: false,
      sumar: ['A101102']
    },
    {
      type: 'operacion',
      id: 'A102101',
      bandas:[1,1,1],
      descripcion: 'Inversiones en valores',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102101'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A102101'],      
    },
    {
      type: 'operacion',
      id: 'A102102',
      bandas:[1,1,1],
      descripcion: 'Inversiones en fondos especiales',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102102'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102102'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A102102'],      
    },
    {
      type: 'operacion',
      id: 'A103101',
      bandas:[1,1,1],
      descripcion: 'Prestamos vigentes',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103101'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A103101'],      
    },
    {
      type: 'operacion',
      id: 'A104101',
      bandas:[1,1,1],
      descripcion: 'Deudores varios',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104101'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104101'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104101'],      
    },
    {
      type: 'ceros',
      id:'CEROS_02',
      bandas:[0,0,0],
      descripcion: 'Comisiones por cobrar',
      visible: false,
      sumar: ['A104103']
    },
    {
      type: 'operacion',
      id: 'A104104',
      bandas:[1,1,1],
      descripcion: 'Intereses sobre préstamos por cobrar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104104'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104104'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104104'],      
    },
    {
      type: 'operacion',
      id: 'A104105',
      bandas:[1,1,1],
      descripcion: 'Intereses y dividendos sobre inversiones por cobrar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104105'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104105'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104105'],      
    },
    {
      type: 'subtotal',
      id: 'SUBTOTAL_01',
      bandas: [1,1,1],
      descripcion: 'TOTAL FLUJOS DE ACTIVOS',
      sumar:['A101101','A101103','CEROS_01','A102101','A102102','A103101','A104101','CEROS_02','A104104','A104105'],
      visible: true,
      expandible: true,
      expandido: false
    },
    {
      type: 'operacion',
      id: 'P201108',
      bandas:[1,1,1],
      descripcion: 'Obligaciones por administración',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201108'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'numero', valor: 0},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201108'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201108'],      
    },
    {
      type: 'operacion',
      id: 'P201109',
      bandas:[1,1,1],
      descripcion: 'Acredores varios',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201109'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201109'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201109'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201109'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201109'],      
    },
    {
      type: 'ceros',
      id:'CEROS_03',
      bandas:[0,0,0],
      descripcion: 'Documentos por pagar',
      visible: false,
      sumar: ['P201120']
    },
    {
      type: 'operacion',
      id: 'P201121',
      bandas:[1,1,1],
      descripcion: 'Cuentas por pagar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201121'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201121'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201121'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201121'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201121'],      
    },
    {
      type: 'operacion',
      id: 'P202101',
      bandas:[1,1,1],
      descripcion: 'Depósitos de ahorro',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202101'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P202101'],      
    },
    {
      type: 'operacion',
      id: 'P202103',
      bandas:[1,1,1],
      descripcion: 'Depósitos a plazo',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202103'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202103'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P202103'],      
    },
    {
      type: 'operacion',
      id: 'P204101',
      bandas:[1,1,1],
      descripcion: 'Obligaciones por préstamos redescontados',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204101'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204101'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204101'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204101'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P204101'],      
    },
    {
      type: 'operacion',
      id: 'P204102',
      bandas:[1,1,1],
      descripcion: 'Créditos y obligaciones bancarias',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204102'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204102'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204102'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204102'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P204102'],      
    },
    {
      type: 'operacion',
      id: 'P201112',
      bandas:[1,1,1],
      descripcion: 'Intereses por pagar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201112'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201112'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201112'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201112'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201112'],      
    },
    {
      type: 'ceros',
      id:'CEROS_04',
      bandas:[0,0,0],
      descripcion: 'Comisiones por pagar',
      visible: false,
      sumar: ['P201113']
    },
    {
      type: 'subtotal',
      id: 'SUBTOTAL_02',
      bandas: [1,1,1],
      descripcion: 'TOTAL FLUJOS DE PASIVOS',
      sumar:['P201108','P201109','CEROS_03','P201121','P202101','P202103','P204101','P204102','P201112','CEROS_04'],
      visible: true,
      expandible: true,
      expandido: false
    },
  ]
}
export const CALCES_PLAZOS_CHOROTEGA_ME: table = {
  columnas: [
    'Código ME',
    'Cuenta',
    "Plazo 1-30 días",
    "Plazo 31-90 días",
    "Plazo 0-90 días",
  ],
  filas: [
    {
      type: 'operacion',
      id: 'A101101',
      bandas:[1,1,1],
      descripcion: 'Caja',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A101201'],
      
    },
    {
      type: 'operacion',
      id: 'A101103',
      bandas:[1,1,1],
      descripcion: 'Depósitos en bancos del interior',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101203'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101203'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A101203'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A101203'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 1.5},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A101203'],
    },
    {
      type: 'ceros',
      id:'CEROS_01',
      bandas:[0,0,0],
      descripcion: 'Depósitos en el banco central',
      visible: false,
      sumar: ['A101202']
    },
    {
      type: 'operacion',
      id: 'A102101',
      bandas:[1,1,1],
      descripcion: 'Inversiones en valores',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A102201'],      
    },
    {
      type: 'operacion',
      id: 'A102102',
      bandas:[1,1,1],
      descripcion: 'Inversiones en fondos especiales',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102202'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102202'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A102202'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A102202'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A102202'],      
    },
    {
      type: 'operacion',
      id: 'A103101',
      bandas:[1,1,1],
      descripcion: 'Prestamos vigentes',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A103201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A103201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A103201'],      
    },
    {
      type: 'operacion',
      id: 'A104101',
      bandas:[1,1,1],
      descripcion: 'Deudores varios',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104201'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104201'],      
    },
    {
      type: 'ceros',
      id:'CEROS_02',
      bandas:[0,0,0],
      descripcion: 'Comisiones por cobrar',
      visible: false,
      sumar: ['A104203']
    },
    {
      type: 'operacion',
      id: 'A104104',
      bandas:[1,1,1],
      descripcion: 'Intereses sobre préstamos por cobrar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104204'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104204'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104204'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104204'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104204'],      
    },
    {
      type: 'operacion',
      id: 'A104105',
      bandas:[1,1,1],
      descripcion: 'Intereses y dividendos sobre inversiones por cobrar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104205'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104205'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'A104205'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consultaAT', valor: 'A104205'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['A104205'],      
    },
    {
      type: 'subtotal',
      id: 'SUBTOTAL_01',
      bandas: [1,1,1],
      descripcion: 'TOTAL FLUJOS DE ACTIVOS',
      sumar:['A101101','A101103','CEROS_01','A102101','A102102','A103101','A104101','CEROS_02','A104104','A104105'],
      visible: true,
      expandible: true,
      expandido: false
    },
    {
      type: 'operacion',
      id: 'P201108',
      bandas:[1,1,1],
      descripcion: 'Obligaciones por administración',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201208'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'numero', valor: 0},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201208'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201208'],      
    },
    {
      type: 'operacion',
      id: 'P201109',
      bandas:[1,1,1],
      descripcion: 'Acredores varios',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201209'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201209'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201209'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201209'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201209'],      
    },
    {
      type: 'ceros',
      id:'CEROS_03',
      bandas:[0,0,0],
      descripcion: 'Documentos por pagar',
      visible: false,
      sumar: ['P201220']
    },
    {
      type: 'operacion',
      id: 'P201121',
      bandas:[1,1,1],
      descripcion: 'Cuentas por pagar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201221'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201221'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201221'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201221'}
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201221'],      
    },
    {
      type: 'operacion',
      id: 'P202101',
      bandas:[1,1,1],
      descripcion: 'Depósitos de ahorro',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202201'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P202201'],      
    },
    {
      type: 'operacion',
      id: 'P202103',
      bandas:[1,1,1],
      descripcion: 'Depósitos a plazo',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P202203'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P202203'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P202203'],      
    },
    {
      type: 'operacion',
      id: 'P204101',
      bandas:[1,1,1],
      descripcion: 'Obligaciones por préstamos redescontados',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204201'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204201'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204201'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204201'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P204201'],      
    },
    {
      type: 'operacion',
      id: 'P204102',
      bandas:[1,1,1],
      descripcion: 'Créditos y obligaciones bancarias',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204202'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204202'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P204202'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P204202'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P204202'],      
    },
    {
      type: 'operacion',
      id: 'P201112',
      bandas:[1,1,1],
      descripcion: 'Intereses por pagar',
      visible: false,
      operaciones:[
        {
          banda: 0,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201212'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201212'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consultaAT', valor: 'P201212'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consultaAT', valor: 'P201212'},
          ]
        }
      ],
      calculo: [1,1,1],
      sumar: ['P201212'],      
    },
    {
      type: 'ceros',
      id:'CEROS_04',
      bandas:[0,0,0],
      descripcion: 'Comisiones por pagar',
      visible: false,
      sumar: ['P201213']
    },
    {
      type: 'subtotal',
      id: 'SUBTOTAL_02',
      bandas: [1,1,1],
      descripcion: 'TOTAL FLUJOS DE PASIVOS',
      sumar:['P201108','P201109','CEROS_03','P201121','P202101','P202103','P204101','P204102','P201112','CEROS_04'],
      visible: true,
      expandible: true,
      expandido: false
    }
  ]
}